import { Injectable } from '@angular/core';
import { ApiPortalService } from './api.portal.service';
import { HttpMethod } from './model/http-method.enum';
import { BusinessUnitPos, DataListSimpleRequest, SelectOption } from './model/portal.data.model';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root' 
 }) 
export class PortalDataService
{
    constructor(private api: ApiPortalService
                ) 
    {
    }

    public async getBusinessUnits(): Promise<SelectOption[]> {
        return this.getData({
            dbName: 'DN.ITF',
            entityName: '[ITF].[CodeListBusinessUnits]',
            columns: ['name','value'],
        } as DataListSimpleRequest);
    }

    public async getBusinessUnitPoses(businessUnitInternalNumber: number): Promise<BusinessUnitPos[]> {
        const qp = {};
        qp['businessUnitInternalNumber'] = businessUnitInternalNumber;
        return this.getDataSP({
            dbName: 'DN.ITF',
            entityName: '[ITF].GetListOfBusinessUnitPOSes',
            columns: ['IpAddress','MachineName','BusinessUnitInternalNumber','PosNumber','LifeDateTime'],
            queryParams: qp,
        } as DataListSimpleRequest);
    }

    public async getData(request: DataListSimpleRequest): Promise<any[]> {
        const rep = await lastValueFrom(this.api.request<any[]>( HttpMethod.POST, 
            'api/report/getData/', 
            request ));

        return rep;                                                                
    }

    public async getDataSP(request: DataListSimpleRequest): Promise<any[]> {
        const rep = await lastValueFrom(this.api.request<any[]>( HttpMethod.POST, 
            'api/report/getDataSP/', 
            request ));

        return rep;                                                                
    }    
}
